import { useRouter } from "next/router";

export const useRouterCaller = () => {
    const router = useRouter();

    return {
        isCallerContentApp: router.query.caller === "contentapp",
    };
};
